<ng-template #modaledicionhtml let-modal>
    <mat-dialog-content>
        <div class="modal-header text-center">
            <div class="headerm">
                <mat-icon aria-hidden="false" aria-label="Example home icon">report</mat-icon>
                <h5 class="modal-title">
                    <div [innerHTML]="TituloMostrar"></div>
                </h5>
            </div>

            <button id="confirmacion_cerrar" type="button" class="close" aria-label="Close" [mat-dialog-close]="false">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <div class="row pr-0 pl-0 mt-4 m-0">
                <div [formGroup]="form" fxLayout="row" fxLayoutAlign="start start" class="row pr-0 pl-0" autocomplete="off">
                    <div class="col-md-12 col-lg-6 col-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Texto Html</mat-label>
                            <textarea matInput formControlName="contenidoHtml" autocomplete="off" rows="20"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-6 col-12">
                        <mat-label>Texto final Html</mat-label>
                        <div [innerHTML]="_ContenidoHtml"></div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button id="confirmacion_no" type="button" class="btn btn-primary" [mat-dialog-close]="false">{{TextoNoMostrar}}</button>
        <button id="confirmacion_si" type="button" class="btn btn-danger" [mat-dialog-close]="true">{{TextoSiMostrar}}</button>
    </mat-dialog-actions>
</ng-template>